$(function () {
  $("textarea").on("keypress", function (e) {
    e.stopPropagation();
  });

  parent.$(".tooltip").tooltip("hide");

  window.handleAlertSuccess = function () {
    setTimeout(function () {
      if (
        $(".alert-success").not(".ignore").length &&
        parent &&
        typeof parent.refresh_data == "function"
      ) {
        if (parent && parent.refresh_data) {
          parent.refresh_data($(".alert-success").html());
        }

        if (
          parent &&
          parent.window &&
          typeof parent.window.refreshSystemNotificationsBadgeNumber ==
            "function"
        ) {
          parent.window.refreshSystemNotificationsBadgeNumber();
        }

        if (parent && parent.hide_modal) {
          parent.hide_modal();
        }
      }
    }, 0);
  };
  window.handleAlertSuccess();

  // special event handlers for when a page is iframed into a modal
  if (window.location !== window.parent.location) {
    // submit form on modal submit button click
    $(".modal-footer [type=submit]").on("click", function () {
      $("form").trigger("submit");
    });

    // hide breadcrumb trail
    $(".breadcrumb").hide();
  }

  /* form change tracker */
  var form_serialized = $("form").serialize();
  parent.form_changed = false;

  $("input, textarea, select").on("input change", function () {
    parent.form_changed =
      $(this).parents("form").serialize() != form_serialized;
  });

  // select all/none
  $(".select-all-none .toggle input")
    .not(".no-auto-bind")
    .on("change", function () {
      var $this = $(this);
      var checked = $this.is(":checked");
      $this
        .parents(".select-all-none")
        .find(".items")
        .find("input")
        .prop("checked", checked);
    });
});
